import { render } from "./Message-Dialog.vue?vue&type=template&id=e264b00e&scoped=true"
import script from "./Message-Dialog.vue?vue&type=script&lang=js"
export * from "./Message-Dialog.vue?vue&type=script&lang=js"

import "./Message-Dialog.vue?vue&type=style&index=0&id=e264b00e&scoped=true&lang=css"
/* custom blocks */
import block0 from "./Message-Dialog.vue?vue&type=custom&index=0&blockType=p"
if (typeof block0 === 'function') block0(script)
import block1 from "./Message-Dialog.vue?vue&type=custom&index=1&blockType=p"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e264b00e"]])

export default __exports__